/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
} from 'react';

import {
  Wrapper,
  Container,
  Line,
  Title,
  Back,
  Description,
  Detail,
  PaymentCard,
  Icon,
  IconPix,
  IconCopyFile,
  IconMessage,
  IconWhatsapp,
  IconMailOpenOutline,
  IconDownload,
  IconPrinter,
  IconCreditCard,
  DownPayment,
  PaymentSectionInfo,
} from './styles';

import { BiCalendar } from 'react-icons/bi';
import { FaChevronRight } from 'react-icons/fa';
import ModalPix from '../../components/Modal/Pix';
import { toast } from 'react-toastify';
import Toast from '../../components/Toast';
import { useHistory, useLocation } from 'react-router-dom';
import GoBackPage from '../../components/GoBackPage';
import { page } from '../../store/auth/actions';
import { getBilletProposal } from '../../store/proposal/actions';
import {
  getBilletDeal,
  getLinhaDigitavelDealBillet,
} from '../../store/agreement/actions';
import { useDispatch, useSelector } from 'react-redux';
import { navigationUrl, payment } from '../../store/analytic/actions';
import { clearDealStatus } from '../../store/negotiation/actions';
import { setWppErrorAction } from '../../store/error/actions';
import {
  getUserConfirmedData,
  setUserConfirmedData,
} from '../../store/auth/actions';
import BreadCrumb from '../../components/BreadCrumb';
import PdfNotify from '../../components/Modal/PdfNotify';
import ConfirmData from '../../components/Modal/ConfirmData';
import api from '../../services/api';
import ClipLoader from 'react-spinners/ClipLoader';
import { Subtitle2 } from '../AgreementSummary/styles';
import { CREDITOR_DEAL_STATUS } from '../Agreement/constants';
import { Button } from '../FinishedDeal/styles';
import { useIframePayment } from '../../contexts/IframePaymentContext';
import { getMessageByPaymentStatus } from '../FinishedDeal';

interface IDetail {
  portion: string;
  value: string;
  date: string;
}

type ProposalProps = {
  contractDebt: GQL.IDebt;
  contractDeal: GQL.IDeal;
  contract: any;
  type: string;
  proposal: GQL.IProposalDetails;
  detail: IDetail;
  dealId: number;
  previousRoute: string;
};

type PaymentMethods = {
  icon: string;
  text: string;
  code: string;
  visible: boolean;
};

const Options: React.FC = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [title, setTitle] = useState('');
  const [open, setOpen] = useState(false);
  const [pdfModal, setPdfModal] = useState<boolean>(false);
  const [telOrEmailModal, setTelOrEmailModal] = useState<boolean>(false);
  const [execCode, setExecCode] = useState<string>('');
  const [toastInfo, setToastInfo] = useState({
    title: '',
    description: '',
  });
  const [debt, setDebt] = useState<GQL.IDebt>();
  const [deal, setDeal] = useState<GQL.IDeal>();
  const location = useLocation<ProposalProps>();
  const [inExecution, setInExecution] = useState<string[]>([]);
  const [posNegotiationMessage, setPosNegotiationMessage] = useState<
    string | null
  >(null);
  const [paymentMethodList, setPaymentmMethodList] = useState<PaymentMethods[]>(
    []
  );
  const noPaymentMethod = useRef<boolean>(false);
  // const contract = location.state && location.state.contract;
  const agreement = location.state && location.state.contractDeal;
  const proposal = location.state && location.state.proposal;
  const detail = location.state && location.state.detail;
  const type: string = location.state ? location.state.type : 'debito';
  const previousRoute = location.state && location.state.previousRoute;
  const downloadLink = useRef<HTMLAnchorElement>(null);
  const config = useSelector((state: ApplicationState) => state.config);
  const negotiationData = useSelector(
    (state: ApplicationState) => state.negotiation
  );
  const { userConfirmedData, updateProfile } = useSelector(
    (state: ApplicationState) => ({
      userConfirmedData: state.auth.userConfirmedData,
      updateProfile: state.auth.updateProfile,
    })
  );
  const { list: listDebts } = useSelector((state: ApplicationState) => ({
    list: state.agreement.list,
  }));
  const [loading, setLoading] = useState(false);
  const portionNumber = window.sessionStorage.getItem('selectedPortionNumber');
  const [activePaymentMethod, setActivePaymentMethod] = useState<string | null>(
    null
  );
  const [iframePayment, setIframePayment] = useState<string | null>(null);
  const [requestIframe, setRequestIframe] = useState(false);
  const [iframeLoading, setIframeLoading] = useState(false);
  const { iframePaymentStatus, clearIframePaymentStatus } = useIframePayment();

  useEffect(() => {
    clearIframePaymentStatus();
  }, [])

  useEffect(() => {
    const handleSendIframeLog = async () => {
      if (!iframePaymentStatus) return;

      const currentDeal = deal ?? agreement;

      if (!currentDeal) return;

      try {
        await api.sendIframeLog({
          databaseId: currentDeal.databaseId,
          responseCode: iframePaymentStatus.responseCode,
          status: iframePaymentStatus.status,
          details: iframePaymentStatus.details,
          auxiliary: iframePaymentStatus.auxiliary,
          agreementId: String(currentDeal.dealId),
          finContract:
            currentDeal?.contractDetails?.[0]?.contract ?? '',
        });
      } catch (error) {
        console.error('Erro ao enviar log do iframe:', error);
      }

      if (!getMessageByPaymentStatus(iframePaymentStatus)) {
        history.replace('/erro');
      }
    };

    handleSendIframeLog();
  }, [iframePaymentStatus]);

  useEffect(() => {
    async function fetchIframePayment() {
      try {
        if (deal) {
          setIframeLoading(true);
          const res = await api.getIframePayment({
            dealId: deal.dealId,
            portionId: 1,
            databaseId: deal.databaseId,
          });
          setIframePayment(res.link);
        }
      } catch (error) {
        console.error(`Erro ao buscar iframe de pagamento: ${error}`);
      } finally {
        setIframeLoading(false);
      }
    }

    if (requestIframe && deal) {
      fetchIframePayment();
    }

  }, [deal, requestIframe])

  if (portionNumber && portionNumber?.trim() && agreement) {
    agreement.portion = parseInt(portionNumber);
  }

  const stateWppError = useSelector(
    (state: ApplicationState) => state.error.wppError
  );

  const billetMsg = useSelector(
    (state: ApplicationState) => state.config.mensagemBoleto
  );

  const handleToastError = useCallback(() => {
    if (stateWppError)
      toast.error(
        <Toast
          title='Não foi possível enviar'
          description='Confirme seu telefone para poder enviar por Whatsapp.'
        />,
        { onClose: () => dispatch(setWppErrorAction(false)) }
      );
  }, [dispatch, stateWppError]);

  const getDealStatus = useCallback(() => {
    const currentDeal = listDebts.find(
      (deal) => deal.dealId === agreement.dealId
    );

    return currentDeal?.status;
  }, [listDebts, agreement]);

  useEffect(() => {
    if (updateProfile) {
      toast.error(
        <Toast title={'Perfil atualizado!'} type={'success'} description={''} />
      );
      dispatch(getUserConfirmedData.request());
      dispatch(setUserConfirmedData.failure(''));
    }
  }, [dispatch, updateProfile]);

  useEffect(() => {
    handleToastError();
  }, [handleToastError, stateWppError]);

  useEffect(() => {
    dispatch(page('opcoes'));
    toastInfo.title.length > 0 &&
      toast.error(
        <Toast
          type='success'
          title={toastInfo.title}
          description={toastInfo.description}
        />
      );
    setLoading(false);
  }, [toastInfo, dispatch]);

  useEffect(() => {
    window.onpopstate = () => {
      if (previousRoute === '/resumo-negociacao') {
        history.replace('/acordos-debitos');
      }
    };

    dispatch(clearDealStatus());
  }, [dispatch]);

  useEffect(() => {
    if (
      negotiationData &&
      negotiationData.negotiationState &&
      (type === 'debito' || type === 'negociacao')
    ) {
      const fetchTermTimeout = setTimeout(() => {
        const negotiation = negotiationData.negotiationState;
        fetchTermBase64(negotiation);
        if (negotiation)
          fetchPosNegotiationMessage(
            debt?.creditorId as number,
            negotiation?.databaseId
          );
      }, 500);
      if (!debt?.creditorId) clearTimeout(fetchTermTimeout);
    }
  }, [
    negotiationData,
    negotiationData.negotiationState,
    debt,
    type,
    location,
    proposal,
  ]);

  useEffect(() => {
    if (type === 'debito' || type === 'negociacao') {
      const option = location.state && location.state.contractDebt;
      setDebt(option);
      setTitle('Acordo Confirmado');
      dispatch(
        navigationUrl.request({
          action: '/opcoesPagamento',
          creditor: option.creditorName,
          dealValue: proposal.entryValue,
          dealType: option.proposalType,
          delay: option.longerDelay,
          plan: proposal.plan,
        })
      );
    } else {
      const option = location.state && location.state.contractDeal;
      setDeal(option);
      setTitle('Pagamento');
      dispatch(
        navigationUrl.request({
          action: '/opcoesPagamento',
          creditor: option.creditorName,
          dealValue: option.portionValue,
          dealType: option.portion,
          delay: 0,
          plan: option.plan,
        })
      );
    }
  }, [type, dispatch, location, proposal]);

  useEffect(() => {
    if (type === 'acordo') {
      if (agreement?.creditorId && agreement?.databaseId >= 0) {
        fetchPosNegotiationMessage(
          agreement?.creditorId,
          agreement?.databaseId
        );
      }
    }
  }, [agreement, type]);

  const checkDealStatus = useCallback(() => {
    if (!listDebts || !agreement) return false;

    const currentDeal = listDebts.find(
      (deal) => deal.dealId === agreement.dealId
    );

    return (
      currentDeal?.status === CREDITOR_DEAL_STATUS.PROM_EM_DIA ||
      currentDeal?.status === CREDITOR_DEAL_STATUS.PROM_CREDOR_ATRASO
    );
  }, [listDebts, agreement]);

  useEffect(() => {
    const list = [
      {
        icon: 'pix',
        text: 'Pagar com PIX',
        code: 'pix',
        visible: config.usaPix === 'true',
      },
      {
        icon: 'Texto',
        text: 'Copiar linha digitável',
        code: 'Texto',
        visible: config.usaCopiarLD === 'true',
      },
      {
        icon: 'SMS',
        text: 'Receber por SMS',
        code: 'SMS',
        visible: config.usaSMSLD === 'true',
      },
      {
        icon: 'Whatsapp',
        text: 'Receber por Whatsapp',
        code: 'Whatsapp',
        visible: config.usaWhatsappLD === 'true',
      },
      {
        icon: 'Email',
        text: 'Receber por E-mail',
        code: 'Email',
        visible: config.usaEmailLD === 'true',
      },
      {
        icon: 'boleto-pdf',
        text: 'Download do Boleto - PDF',
        code: 'boleto-pdf',
        visible: config.usaDownloadBoleto === 'true',
      },
      {
        icon: 'boleto-imprimir',
        text: 'Imprimir Boleto',
        code: 'boleto-imprimir',
        visible: config.usaImprimirBoleto === 'true',
      },
      {
        icon: 'credit-card',
        text: 'Pagar com Cartão de Crédito',
        code: 'credit-card',
        visible: !checkDealStatus(),
      },
    ];
    noPaymentMethod.current = list.every(
      (paymentMethod) => !paymentMethod.visible
    );
    setPaymentmMethodList(list);
  }, [config]);

  async function fetchPosNegotiationMessage(
    creditorId: number,
    credorDatabaseId: number
  ): Promise<void> {
    const { mensagemPosNegociacao } = await api.getPosNegotiationMessage({
      creditorId,
      credorDatabaseId,
    });

    if (mensagemPosNegociacao) setPosNegotiationMessage(mensagemPosNegociacao);
  }

  const base64ToBlob = (base64: string, type = 'application/octet-stream') => {
    const binStr = atob(base64);
    const len = binStr.length;
    const arr = new Uint8Array(len);
    for (let i = 0; i < len; i++) {
      arr[i] = binStr.charCodeAt(i);
    }
    return new Blob([arr], { type: type });
  };

  const handleTermDeal = (term: string | null): void => {
    if (term) {
      const blob = base64ToBlob(term, 'application/pdf');
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open('');
      pdfWindow!.document.write(
        "<iframe width='100%' height='100%' src='" + url + "'></iframe>"
      );
    }
  };

  function fetchTermBase64(data: GQL.IInsertNegotiationModel | undefined) {
    if (data) {
      api
        .getTermDeal({
          options: {
            dealId: data.dealId,
            creditorId: debt?.creditorId as number,
            contract: debt?.contractDetails?.[0]?.contract as string,
          },
          databaseId: data.databaseId,
        })
        .then((termResponse) => {
          handleTermDeal(termResponse);
        });
    }
  }

  const getIcon = (icon: string) => {
    switch (icon) {
      case 'pix':
        return <IconPix />;
      case 'Texto':
        return <IconCopyFile />;
      case 'SMS':
        return <IconMessage />;
      case 'Whatsapp':
        return <IconWhatsapp />;
      case 'Email':
        return <IconMailOpenOutline />;
      case 'boleto-pdf':
        return <IconDownload />;
      case 'boleto-imprimir':
        return <IconPrinter />;
      case 'credit-card':
        return <IconCreditCard />;
      default:
        return;
    }
  };

  const handleBoletoPDF = (base64: {
    linhaDigitavel: string;
    nnumero: string;
    doc: string;
  }) => {
    const code = base64.doc === 'pdf' ? 'boleto-pdf' : 'boleto-imprimir';

    setInExecution((state) => state.filter((action) => action !== code));

    if (type === 'debito') {
      dispatch(
        payment.request({
          paymentType: 11,
          billetType: base64.doc === 'pdf' ? 17 : 18,
          creditor: debt ? debt.creditorName : '',
          portion: 1,
          plan: proposal.plan,
          value: proposal.entryValue,
          dueDate: debt ? debt.proposalDueDate : '',
          billetNumber: Number.parseInt(base64.nnumero ?? '0'),
        })
      );
      dispatch(
        navigationUrl.request({
          action: base64.doc === 'pdf' ? '/downloadBoleto' : '/imprimeBoleto',
          creditor: debt && debt.creditorName,
          dealValue: proposal.entryValue,
          dealType: debt && debt.proposalType,
          delay: debt && debt.longerDelay,
          plan: proposal.plan,
        })
      );
    } else {
      dispatch(
        payment.request({
          paymentType: 11,
          billetType: base64.doc === 'pdf' ? 17 : 18,
          creditor: deal?.creditorName ?? '',
          portion: deal?.portion ?? 0,
          plan: deal?.plan ?? 0,
          value: deal?.portionValue ?? 0,
          dueDate: detail && detail.date,
          billetNumber: Number.parseInt(base64.nnumero ?? '0'),
        })
      );
      dispatch(
        navigationUrl.request({
          action: base64.doc === 'pdf' ? '/downloadBoleto' : '/imprimeBoleto',
          creditor: deal?.creditorName,
          dealValue: deal?.portionValue,
          dealType: deal?.portion,
          delay: 0,
          plan: deal?.plan,
        })
      );
    }

    if (code === 'boleto-imprimir') {
      const blob = base64ToBlob(base64.linhaDigitavel, 'application/pdf');
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open('');
      pdfWindow!.document.write(
        "<iframe width='100%' height='100%' src='" + url + "'></iframe>"
      );
    } else {
      downloadLink.current!.target = '_self';
      downloadLink.current!.href = `data:application/pdf;base64,${base64.linhaDigitavel}`;
      downloadLink.current!.click();
    }

    setLoading(false);
  };

  const handleSendBillet = (sendType: GQL.SendType, billet: GQL.IBillet) => {
    setInExecution((state) => state.filter((action) => action !== sendType));

    switch (sendType) {
      case 'Texto':
        var input = document.createElement('input');
        document.body.appendChild(input);
        input.value = billet.linhaDigitavel;
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
        if (type === 'debito') {
          dispatch(
            navigationUrl.request({
              action: '/copiaLinhaDigitavel',
              creditor: debt && debt.creditorName,
              dealValue: proposal.entryValue,
              dealType: debt && debt.proposalType,
              delay: debt && debt.longerDelay,
              plan: proposal.plan,
            })
          );
          dispatch(
            payment.request({
              paymentType: 11,
              billetType: 13,
              creditor: debt ? debt.creditorName : '',
              portion: 1,
              plan: proposal.plan,
              value: proposal.entryValue,
              dueDate: debt ? debt.proposalDueDate : '',
              billetNumber: Number.parseInt(billet.nnumero ?? '0'),
            })
          );
        } else {
          dispatch(
            navigationUrl.request({
              action: '/copiaLinhaDigitavel',
              creditor: deal?.creditorName,
              dealValue: deal?.portionValue,
              dealType: deal?.portion,
              delay: 0,
              plan: deal?.plan,
            })
          );
          dispatch(
            payment.request({
              paymentType: 11,
              billetType: 13,
              creditor: deal?.creditorName ?? '',
              portion: deal?.portion ?? 0,
              plan: deal?.plan ?? 0,
              value: deal?.portionValue ?? 0,
              dueDate: detail && detail.date,
              billetNumber: Number.parseInt(billet.nnumero ?? '0'),
            })
          );
        }
        setToastInfo({
          title: 'Linha digitável copiada!',
          description:
            'A linha digitável foi copiada para a sua área de transferência.',
        });
        break;
      case 'SMS':
        sendAnalyticStatus(
          'Pagamento enviado por SMS',
          14,
          Number.parseInt(billet.nnumero ?? '0')
        );
        setToastInfo({
          title: 'SMS enviado!',
          description: billet.linhaDigitavel,
        });
        break;
      case 'Whatsapp':
        sendAnalyticStatus(
          'Pagamento enviado por Whatsapp',
          15,
          Number.parseInt(billet.nnumero ?? '0')
        );
        setToastInfo({
          title: 'Enviado para Whatsapp!',
          description: billet.linhaDigitavel,
        });
        break;
      case 'Email':
        sendAnalyticStatus(
          'Pagamento enviado por E-mail',
          16,
          Number.parseInt(billet.nnumero ?? '0')
        );
        setToastInfo({
          title: 'Enviado por E-mail',
          description: billet.linhaDigitavel,
        });
        break;
    }

    setLoading(false);
  };

  const sendAnalyticStatus = (
    action: string,
    billet: number,
    nnumero: number
  ) => {
    if (type === 'debito') {
      dispatch(
        navigationUrl.request({
          action: action,
          creditor: debt && debt.creditorName,
          dealValue: debt && debt.updatedValue,
          dealType: debt && debt.proposalType,
          delay: debt && debt.longerDelay,
          plan: proposal.plan,
        })
      );
      dispatch(
        payment.request({
          paymentType: 11,
          billetType: billet,
          creditor: debt ? debt.creditorName : '',
          portion: 1,
          plan: proposal.plan,
          value: proposal.entryValue,
          dueDate: debt ? debt.proposalDueDate : '',
          billetNumber: nnumero,
        })
      );
    } else {
      dispatch(
        navigationUrl.request({
          action: action,
          creditor: deal?.creditorName,
          dealValue: deal?.portionValue,
          dealType: deal?.portion,
          delay: 0,
          plan: deal?.plan,
        })
      );
      dispatch(
        payment.request({
          paymentType: 11,
          billetType: billet,
          creditor: deal?.creditorName ?? '',
          portion: deal?.portion ?? 0,
          plan: deal?.plan ?? 1,
          value: deal?.portionValue ?? 0,
          dueDate: detail && detail.date,
          billetNumber: nnumero,
        })
      );
    }
  };

  const handleClickBoletoPDF = (code: string, doc: string) => {
    if (!inExecution.includes(code)) {
      setInExecution((state) => [...state, code]);

      if (billetMsg) {
        setPdfModal(true);
      }

      downloadLink.current!.target = code;
      if (type === 'debito') {
        dispatch(
          getBilletProposal.request({
            databaseId: deal?.databaseId ?? debt?.databaseId!,
            planId: 0,
            proposalId: 0,
            type: doc,
            callBack: handleBoletoPDF,
          })
        );
      } else {
        dispatch(
          getBilletDeal.request({
            dealId: deal?.dealId ?? location.state.dealId,
            portionId: deal?.portion ?? 1,
            type: doc,
            databaseId: deal?.databaseId ?? debt?.databaseId!,
            callBack: handleBoletoPDF,
          })
        );
      }
    }
  };

  const handleClickSendBillet = (code: string) => {
    if (!inExecution.includes(code)) {
      if (code === 'Email') {
        if (!userConfirmedData?.email) {
          setTelOrEmailModal(true);
          setExecCode(code);
        } else {
          setInExecution((state) => [...state, code]);
          dispatch(
            getLinhaDigitavelDealBillet.request({
              dealId: agreement?.dealId ?? location.state.dealId,
              portionId: agreement?.portion ?? 1,
              sendType: code,
              databaseId: deal?.databaseId ?? debt?.databaseId!,
              callBack: handleSendBillet,
              creditorId: agreement?.creditorId,
            })
          );
        }
      } else if (code === 'SMS' || code === 'Whatsapp') {
        if (!userConfirmedData?.telephone) {
          setTelOrEmailModal(true);
          setExecCode(code);
        } else {
          setInExecution((state) => [...state, code]);
          dispatch(
            getLinhaDigitavelDealBillet.request({
              dealId: agreement?.dealId ?? location.state.dealId,
              portionId: agreement?.portion ?? 1,
              sendType: code,
              databaseId: deal?.databaseId ?? debt?.databaseId!,
              callBack: handleSendBillet,
              creditorId: agreement?.creditorId,
            })
          );
        }
      } else {
        setInExecution((state) => [...state, code]);
        dispatch(
          getLinhaDigitavelDealBillet.request({
            dealId: agreement?.dealId ?? location.state.dealId,
            portionId: agreement?.portion ?? 1,
            sendType: code,
            databaseId: deal?.databaseId ?? debt?.databaseId!,
            callBack: handleSendBillet,
            creditorId: agreement?.creditorId,
          })
        );
      }
    }
  };

  function handleNavigationWithOptions(pathname: string, data: unknown) {
    history.push({ pathname, state: { contract: data, paymentType: 2 } });
  }

  const handlerOpen = (code: string) => {
    setLoading(true);
    setActivePaymentMethod(code);
    switch (code) {
      case 'pix':
        setOpen(true);
        break;
      case 'Texto':
      case 'SMS':
      case 'Whatsapp':
      case 'Email':
        handleClickSendBillet(code);
        break;
      case 'boleto-pdf':
        handleClickBoletoPDF(code, 'pdf');
        break;
      case 'boleto-imprimir':
        handleClickBoletoPDF(code, 'print');
        break;
      case 'credit-card':
        handleNavigationWithOptions('/resumo-acordo', agreement);
        break;
      default:
        setToastInfo({ title: '', description: 'Opção inválida' });
    }
  };

  const handlerClose = (): void => {
    setOpen(false);
    setPdfModal(false);
    setTelOrEmailModal(false);
    setActivePaymentMethod(null);
    if (type === 'debito') {
      dispatch(
        navigationUrl.request({
          action: '/fecharPIX',
          creditor: debt && debt.creditorName,
          dealValue: proposal.entryValue,
          dealType: debt && debt.proposalType,
          delay: debt && debt.longerDelay,
          plan: proposal.plan,
        })
      );
    } else {
      dispatch(
        navigationUrl.request({
          action: '/fecharPIX',
          creditor: deal && deal.creditorName,
          dealValue: deal && deal.portionValue,
          dealType: deal && deal.portion,
          delay: 0,
          plan: deal && deal.plan,
        })
      );
    }
  };

  const breadCrumbProps = useMemo(() => {
    //Acordos
    if (location.state.type === 'acordo') {
      return {
        previousPages: [
          { name: 'Débitos e Acordos', route: '/acordos' },
          { name: 'Meu Acordo', route: '/parcela-acordo' },
        ],
        currentPage: 'Pagamento',
      };
    } else {
      //Debito || Proposta
      return {
        previousPages: [{ name: 'Débitos e Acordos', route: '/contrato' }],
        currentPage: 'Acordo',
        goBackTo: { name: 'Débitos e Acordos', route: '/contrato' },
      };
    }
  }, [location, type]);

  return (
    <Wrapper>
      <a
        style={{ display: 'none' }}
        ref={downloadLink}
        download={'boleto.pdf'}
      />
      <Container>
        <Line>
          <Title>{title}</Title>
          <BreadCrumb
            previouPages={breadCrumbProps.previousPages}
            currentPage={breadCrumbProps.currentPage}
            {...(breadCrumbProps.goBackTo?.route && {
              onNavigateBackTo: () => {
                history.replace(breadCrumbProps.goBackTo?.route as string);
              },
            })}
            showBreadCrumbOnMinWidth='960px'
          />
          <Back>
            <GoBackPage text={title} />
          </Back>
        </Line>
        <Description>
          {type === 'debito'
            ? 'Confira as informações do acordo e escolha uma das opções para realizar o pagamento da entrada:'
            : 'Confira as informações da parcela e escolha uma das opções para realizar o pagamento:'}
        </Description>

        <Detail>
          <PaymentSectionInfo>
            <DownPayment hasPortion={!!detail.portion}>
              <p>
                {title === 'Acordo Confirmado'
                  ? `${detail.portion}`
                  : `Parcela ${detail.portion}`}
              </p>
              <span>R$ {detail.value}</span>
            </DownPayment>
          </PaymentSectionInfo>
          <div className='time'>
            <BiCalendar className='space-right' />
            Vencimento {type === 'debito' && 'da entrada'}:{' '}
            <span className='strong' style={{ marginLeft: '5px' }}>
              {detail.date}
            </span>
          </div>
        </Detail>
        {
          iframePayment && !iframePaymentStatus && (
            <iframe
              src={iframePayment}
              title='Iframe de Pagamento'
              width='100%'
              height='600px'
              style={{ border: 'none', borderRadius: '8px', marginTop: '10px' }}
              allow="payment"
            />
          )
        }

        {!iframePayment && (
          <Button
            color='primary'
            onClick={() => setRequestIframe(true)}
            disabled={iframeLoading}
          >
            <p style={{ fontSize: '16px', fontWeight: 'bold' }}>{iframeLoading ? 'Aguarde...' : 'Efetuar Pagamento'}</p>
          </Button>
        )}

        {
          iframePaymentStatus?.status &&
          getMessageByPaymentStatus(iframePaymentStatus)
          && getMessageByPaymentStatus(iframePaymentStatus)
        }
      </Container>

      {telOrEmailModal && (
        <ConfirmData
          handlerClose={handlerClose}
          sendData={(code: string) => handleClickSendBillet(code)}
          setDataModal={setTelOrEmailModal}
          code={execCode}
        />
      )}

      {open && (
        <ModalPix
          portionId={deal?.portion ?? agreement?.portion}
          databaseId={deal?.databaseId ?? debt?.databaseId!}
          dealId={deal?.dealId ?? location.state.dealId}
          data={type === 'debito' ? debt : deal}
          handlerClose={handlerClose}
        />
      )}

      {pdfModal && (
        <PdfNotify
          handlerClose={handlerClose}
          billetMsg={billetMsg}
          billetWarning
        />
      )}
    </Wrapper>
  );
};

export default Options;
